import React, {useEffect, useState} from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import NavBar from '../general/nav_bar';
import Footer from '../general/footer';

const Layout = ({ children }) => {
    const location = useLocation()
    const [isInternalPath, setIsInternalPath] = useState(false)
    useEffect(()=>{
        if(location.pathname === "/jfLogin")
            setIsInternalPath(true)
    },[location])
    return (
        <>

            <NavBar display={!isInternalPath}/>
            <ScrollRestoration />
            <div>{children}</div>
            <Outlet />
            <Footer display={!isInternalPath}/>
 
        </>
    );

};

export default Layout;